import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OccEndpointsService} from '@spartacus/core';
import {CountrySelectorService} from '../services/country-selector.service';
import jwt_decode from 'jwt-decode';
import {DcpJwtPayload} from '../model/user/dcp-jwt-playload';

@Injectable()
export class CustomSiteContextInterceptor implements HttpInterceptor {
  constructor(private occEndpoints: OccEndpointsService, private countrySelectorService: CountrySelectorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url?.includes(this.occEndpoints.getBaseUrl())) {
      const tokenCountry: string = this.extractCountryFromToken(req.headers.get('authorization'));
      const country: string =
        req.headers.get('country') || tokenCountry || this.countrySelectorService.getCurrentCountry().isocode;
      req = req.clone({
        setHeaders: {
          country,
        },
        setParams: {
          curr: '',
        },
      });
    }
    return next.handle(req);
  }

  private extractCountryFromToken(headerToken: string): string {
    let tokenCountry;
    if (headerToken) {
      const authToken: DcpJwtPayload = jwt_decode<DcpJwtPayload>(headerToken);
      tokenCountry = authToken.company_country || authToken.country;
    }
    return tokenCountry;
  }
}
